import axios from "axios";
import React, { useEffect, useState } from "react";
import { getCurrentFY } from "../../Utilitie";
import Loading from "../../Extra/Loading";
import CrewPDDFilter from "./CrewPDDFilter";
import MonthWisePDD from "./MonthWisePDD";
import LobbyWisePDD from "./LobbyWisePdd";
const opState = {
  Year: false,
  Months: false,
  Lobby: false,
};
// Unique colors per column
const barColors = {
  c1: "#1D4ED8", // deep royal blue
  c2: "#2563EB", // strong blue
  c3: "#0284C7", // cyan-blue
  c4: "#0891B2", // teal-blue
  c5: "#14B8A6", // clear teal
  total: "#0D9488", // deep teal (stands out as total)
};
const CrewPDDMaster = () => {
  const [pddData, setPddData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState({});
  const urlPrefixBlock = process.env.REACT_APP_URL_CMS_PREFIX;
  const [filteredData, setFilteredData] = useState(null);
  const [openStates, setOpenStates] = useState(opState);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [year, setYear] = useState(getCurrentFY().slice(0, 4));
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i); // last 10 years
  const fetchData = async () => {
    setLoading(true);
    try {
      const response =
        await axios.get(`${urlPrefixBlock}fetch_cms_pdd?PDD_YEAR=${year}

`);
      setLoading(false);
      if (response.statusText === "OK") {
        setPddData([
          ...response.data.current_data,
          // ...response.data.previous_data,
        ]);
      }
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [year]);
  return (
    <div onClick={() => setOpenStates(opState)}>
      <div className=" bg-dark text-white ps-2 p-1 d-flex align-items-center justify-content-between ">
        <div>
          <h5>Crew PDD</h5>
        </div>
        <div className="row pe-3 d-flex align-items-center">
          <b className="col-md text-end" style={{ fontSize: "18px" }}>
            Year
          </b>
          <div className="col-md">
            <select
              style={{ width: "100px", height: "35px" }}
              className="form-select"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="">--FY-- </option>
              {years.map((yr, i) => (
                <option key={yr} value={yr}>
                  {yr}-{String(yr + 1).slice(2, 4)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {loading && <Loading />}
      {pddData && (
        <div className="sticky-controller">
          <CrewPDDFilter
            data={pddData}
            setSelectedFilters={setSelectedFilters}
            setFilteredData={setFilteredData}
            openStates={openStates}
            setOpenStates={setOpenStates}
          />
        </div>
      )}
      {filteredData && (
        <MonthWisePDD
          data={filteredData}
          barColors={barColors}
          setSelectedMonth={setSelectedMonth}
          selectedMonth={selectedMonth}
        />
      )}
      <br />
      {filteredData && (
        <LobbyWisePDD
          data={filteredData}
          selectedFilters={selectedFilters}
          barColors={barColors}
          setSelectedMonth={setSelectedMonth}
          selectedMonth={selectedMonth}
        />
      )}
    </div>
  );
};
export default CrewPDDMaster;
